export const passerelleA2AData = {
  path: '/passerelle-a2-a',
  breadcrumb: [
    ['Formations 2 & 3 roues', '/formation'],
    ['Passerelle A2 → A', '/passerelle-a2-a'],
  ],
  kicker: 'Passerelle · 7 heures · dès 20 ans',
  title: 'Passerelle A2 → A',
  titleHighlight: 'le permis sans limite.',
  subtitle:
    "Après 2 ans de permis A2, une formation de 7 heures te permet d'accéder à toutes les motos sans limite de puissance. Pas de plateau, pas de circulation à repasser.",
  seoTitle: 'Passerelle A2 vers A — Formation 7h sans examen • Permis moto sans limite',
  seoDescription:
    'La passerelle A2 → A : 7 heures de formation (théorie + maniabilité + circulation), sans examen final. Déroulement, prix, conditions et conseils ECSR.',
  seoKeywords:
    'passerelle a2 a, formation a2 vers a, permis moto sans limite, formation 7h moto, passerelle moto 2 ans, permis a après a2',
  heroImage:
    'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=2400&q=85&auto=format&fit=crop',
  heroImageAlt: 'Moto sportive sans limite de puissance — permis A',
  duration: '7 heures (1 journée)',
  cost: '~ 250 à 400 €',
  timeRequired: 'PT7H',
  about: 'Permis A, passerelle A2, formation 7h, moto sans limite',
  primaryCta: { label: 'Voir les formations', to: '/formation' },
  secondaryCta: { label: 'Permis A2 — le guide', to: '/permis-a2' },
  relatedTopic: 'passerelle-a2-a',

  intro:
    "<p>La <strong>passerelle A2 → A</strong> est le passage <strong>obligatoire</strong> en France pour accéder à toutes les motos sans limite de puissance. Pas de permis A direct : tu dois <strong>obligatoirement</strong> passer par le A2 (à 18 ans), conduire 2 ans, puis suivre cette formation de <strong>7 heures</strong>.</p><p>Bonne nouvelle : <strong>aucun examen final</strong>. À l'issue des 7 heures, ton moniteur valide la formation et tu reçois ton attestation A. Tu peux ensuite conduire <strong>n'importe quelle moto</strong> (Hayabusa, ZX-10R, Panigale V4...).</p>",

  conditions: [
    {
      title: 'Permis A2 depuis 2 ans',
      text: '2 ans pleins de permis A2 valide à la date de la formation. Si tu as obtenu ton A2 le 15 mars 2024, tu peux faire la passerelle dès le 15 mars 2026.',
    },
    {
      title: 'Aucune suspension récente',
      text: "Pas de suspension de permis dans les 2 ans précédant la formation. Si tu as eu une suspension de plus de 6 mois, le compteur redémarre.",
    },
    {
      title: 'En moto-école agréée',
      text: "La formation passerelle ne peut être dispensée que par une moto-école agréée par la préfecture. Vérifie la mention \"Formation A2/A\" sur leur affichage.",
    },
    {
      title: 'Aucun prérequis théorique',
      text: "Pas d'ETM à repasser, pas d'ASSR à fournir : ton permis A2 est suffisant. Tu apportes simplement ta carte grise et ton casque.",
    },
  ],

  steps: [
    {
      title: 'Module théorique (2h)',
      duration: '2 heures',
      text: 'Sensibilisation aux risques spécifiques de la conduite à forte puissance : couple moteur, freinage à haute vitesse, spécificités aérodynamiques, comportement à grande vitesse. Échanges en groupe.',
    },
    {
      title: 'Module maniabilité hors circulation (2h)',
      duration: '2 heures',
      text: "Sur piste fermée avec une moto > 35 kW. Allure lente, freinage d'urgence à 60+ km/h, slalom, gestion du couple. Tu découvres la différence avec ton A2.",
    },
    {
      title: 'Module circulation (3h)',
      duration: '3 heures',
      text: 'Conduite en conditions réelles : ville, hors agglomération, voie rapide. Apprentissage de la gestion d\'une moto puissante en circulation, anticipation, trajectoires.',
    },
    {
      title: 'Bilan + délivrance attestation',
      duration: '15 minutes',
      text: 'Pas d\'examen, mais une évaluation continue par le moniteur tout au long des 7h. Si tout est OK : attestation \"Formation 7h A2→A\" remise. Tu reçois ton permis A officiel sous 4-8 semaines.',
    },
  ],

  erreurs: [
    {
      title: 'Vouloir aller trop vite',
      text: 'Le but de la passerelle n\'est pas de te tester mais de te sensibiliser. Si tu fais le malin avec la moto puissante, le moniteur peut refuser de valider.',
    },
    {
      title: 'Sous-estimer la différence A2 / A',
      text: 'Une moto > 80 kW (110+ ch) accélère BEAUCOUP plus fort qu\'une A2. Ne pas anticiper = chute potentielle dès la 1ʳᵉ sortie.',
    },
    {
      title: 'Oublier le débridage administratif',
      text: 'Si ta moto actuelle est bridée A2 (kit constructeur), tu dois faire débrider chez un pro + faire mettre à jour ta carte grise après la passerelle.',
    },
    {
      title: 'Croire qu\'il y a un examen',
      text: 'Il n\'y a PAS d\'examen final, juste une évaluation continue. Si tu échoues, c\'est que tu n\'étais clairement pas prêt. Très rare en pratique.',
    },
  ],

  conseils: [
    'Choisis une moto-école avec une moto > 80 kW (Tracer 9, Z900, MT-09) : tu sentiras vraiment la différence avec ton A2.',
    'Apporte ton propre équipement (casque, gants) : tu seras plus à l\'aise.',
    "Profite des 2h théoriques pour poser TOUTES tes questions — le moniteur a 25+ ans d'expérience.",
    'Après la passerelle : ne saute pas direct sur une 200 ch. Une montée en puissance progressive est plus sûre.',
    "Pense au stage perfectionnement post-permis (anti-dérapage, freinage d'urgence) proposé par certaines moto-écoles.",
  ],

  faq: [
    {
      q: 'Faut-il vraiment 2 ans de permis A2 pour la passerelle ?',
      a: '2 ans pleins. Si tu as obtenu ton A2 le 1er janvier 2024, tu peux passer la formation A2→A à partir du 1er janvier 2026. Le calcul se fait à la date d\'obtention sur ton permis.',
    },
    {
      q: 'Combien coûte la formation passerelle ?',
      a: 'Entre 250 et 400 € selon les régions. Le tarif inclut la moto, le carburant, les 7 heures de formation et la délivrance de l\'attestation. Pas de frais d\'examen (il n\'y a pas d\'examen).',
    },
    {
      q: 'Y a-t-il un examen final à la passerelle ?',
      a: 'NON. La passerelle est une formation, pas un examen. Le moniteur évalue tes compétences au fil des 7 heures. Si tu suis correctement la formation, tu obtiens automatiquement ton attestation. Échec rarissime.',
    },
    {
      q: 'Que puis-je conduire après la passerelle A2 → A ?',
      a: 'Toutes les motos sans limite de puissance. Du 600 sportive au 1800 cruiser, en passant par les hyperbikes (Hayabusa, ZX-14R...). Tu peux aussi conduire un side-car (avec le permis A direct).',
    },
    {
      q: 'La passerelle A2 → A est-elle valable à l\'étranger ?',
      a: 'Oui, dans tous les pays de l\'UE (équivalence directe). Aux États-Unis et hors UE : à vérifier au cas par cas. Souvent, il faut un permis international en complément.',
    },
    {
      q: 'Peut-on faire la passerelle plus de 2 ans après le A2 ?',
      a: 'Oui, sans limite de temps maximum. Tu peux passer ta passerelle 2 ans, 5 ans ou 20 ans après ton A2 — tant que ton permis A2 est toujours valide (pas suspendu / annulé). Même moto, même attestation finale.',
    },
  ],

  sourceLabel:
    'Décret 2016-723 du 31 mai 2016, arrêté du 23 avril 2012 modifié, Sécurité routière.',
  sourceUrl: 'https://www.securite-routiere.gouv.fr/passer-son-permis-de-conduire/permis-moto',
};
